import React, { Component } from 'react';

class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {

        return (
            <div className="header-back">
                <div className="header-wrapper">
                    <div className="logo-nav-wrapper">
                        <div className="logo">
                            <a href="https://mevu.bet/"><img src="img/logo.svg" width="120px" /></a>
                        </div>
                        <nav>
                            <input type="checkbox" id="css-toggle-menu" name="css-toggle-menu" />
                            <ul className="main">
                                <li><a href="https://mevu.bet/#desc">About</a></li>
                                <li><a href="https://mevu.bet/#team">Team</a></li>
                                <li><a href="https://mevu.bet/#cta">Contact</a></li>
                                <li><a href="https://github.com/mevu-bet/mevu" target="_blank">Github</a></li>
                            </ul>
                            <label htmlFor="css-toggle-menu" id="css-toggle-menu" />
                        </nav>

                    </div>
                    <div className="row header-title-wrap animated bounceIn delay-120ms">
                        <div className="col">
                            <div className="steps-title">meVu, step-by-step</div>
                            <div className="steps-subtitle">Click through our platform demo steps</div>
                        </div>
                    </div>
                    <div className="row steps animated bounceIn delay-120ms">
                        <a href="#select-sport" className="col step">
                            <div className="step-wrap">
                                <div className="step-title">1</div>
                                <div className="step-description">Select a Sport</div>
                            </div>
                        </a>
                        <a href="#select-match" className="col step">
                            <div className="step-wrap">
                                <div className="step-title">2</div>
                                <div className="step-description">Select a Match</div>
                            </div>
                        </a>
                        <a href="#select-winner" className="col step">
                            <div className="step-wrap">
                                <div className="step-title">3</div>
                                <div className="step-description">Place your Bet</div>
                            </div>
                        </a>
                        <a href="#leaders" className="col step-no-after">
                            <div className="step-wrap">
                                <div className="step-title">4</div>
                                <div className="step-description">Take over the leaderboard</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js